var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.739 16.706a5.275 5.275 0 0 1-5.239 4.586c-7.444 0-13.5-6.056-13.5-13.5a5.274 5.274 0 0 1 4.586-5.239 1.5 1.5 0 0 1 1.558.893l1.98 4.42v.011a1.5 1.5 0 0 1-.119 1.415l-.053.072L9 11.678c.702 1.427 2.195 2.906 3.64 3.61l2.282-1.941a1.501 1.501 0 0 1 1.492-.184l.013.005 4.416 1.98a1.5 1.5 0 0 1 .896 1.558"
  })));
};
export default SvgPhone;